
  <div class="login-container">
    <img src="../../assets/images/logos/investa-bill-white.png" alt="img" class="login-logo">
    <div class="login-box">
      <div class="login-header">
        <h2>REGISTER</h2>
      </div>
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <input type="text" id="firstName" placeholder="First Name" formControlName="firstName" required>
          <div *ngIf="f['firstName'].invalid && (f['firstName'].dirty || f['firstName'].touched)">
            <div class="error-msg" *ngIf="f['firstName'].errors?.['required']">First Name is required.</div>
          </div>
        </div>
        <div class="form-group">
          <input type="text" id="lastName" placeholder="Last Name" formControlName="lastName" required>
          <div *ngIf="f['lastName'].invalid && (f['lastName'].dirty || f['lastName'].touched)">
            <div class="error-msg" *ngIf="f['lastName'].errors?.['required']">Last Name is required.</div>
          </div>
        </div>
        <div class="form-group">
          <input type="text" id="organisation" placeholder="Organisation" formControlName="organisation" required>
          <div *ngIf="f['organisation'].invalid && (f['organisation'].dirty || f['organisation'].touched)">
            <div class="error-msg" *ngIf="f['organisation'].errors?.['required']">Organisation is required.</div>
          </div>
        </div>
        <div class="form-group">
          <input type="text" id="mobilePhone" placeholder="Mobile Phone" formControlName="mobilePhone" required>
          <div *ngIf="f['mobilePhone'].invalid && (f['mobilePhone'].dirty || f['mobilePhone'].touched)">
            <div class="error-msg" *ngIf="f['mobilePhone'].errors?.['required']">Mobile Phone is required.</div>
            <div class="error-msg" *ngIf="f['mobilePhone'].errors?.['pattern']">Please enter a valid mobile phone number.</div>
          </div>
        </div>
        <div class="form-group">
          <input type="email" id="email" placeholder="Email" formControlName="email" required>
          <div *ngIf="f['email'].invalid && (f['email'].dirty || f['email'].touched)">
            <div class="error-msg" *ngIf="f['email'].errors?.['required']">Email is required.</div>
            <div class="error-msg" *ngIf="f['email'].errors?.['email']">Please enter a valid email address.</div>
          </div>
        </div>
        <div class="form-group">
          <button type="submit" [disabled]="registerForm.invalid">{{submitText}}</button>
        </div>
      </form>
      <div class="login-links">
        <a routerLink="/login">Back to Login</a>
      </div>
    </div>
  </div>
